import { get, map, castArray, compact, sumBy } from 'lodash';

export const getItemPromotions = (item) => compact(castArray(get(item, 'promotions', [])));

export const mapPromotionsToPriceTags = (item) => map(getItemPromotions(item), (promotion) => ({
    value: get(promotion, 'value', 0),
    rateAndBenefit: { name: get(promotion, 'name', '') }
}));

export const getPromotionsDiscount = (item) => {
    const pickingQuantity = parseFloat(get(item, 'pickingQuantity', 1)) || 1;
    return sumBy(getItemPromotions(item), (promotion) => (parseFloat(get(promotion, 'rawValue', 0)) || 0) / pickingQuantity);
};

export const buildAddedItem = (item) => {
    const price = `${get(item, 'price', '000')}`;
    const listPrice = price.substring(0, price.length - 2);
    return {
        ...item,
        basePrice: listPrice,
        listPrice,
        sellingPrice: parseFloat(listPrice) + getPromotionsDiscount(item),
        priceTags: mapPromotionsToPriceTags(item),
        quantity: get(item, 'pickingQuantity', 1)
    };
};
